'use es6';

// TODO this is basically a copy of the smart content HOC so when we do have some form of inpage lib this should go there
import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { closeModal } from 'ContentEditorUI/redux/actions/appActions';
import { getOpenModal, getOpenModalMetadata } from 'ContentEditorUI/redux/selectors/modalSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
export default function withModalProps(WrappedComponent, modalType) {
  /**
   * @param {Object} props
   * @param {boolean} props.isOpen (required)
   * @param {Function} props.onClose (required)
   */
  class HighOrderComponentWithModalProps extends PureComponent {
    render() {
      if (!this.props.isOpen) return null;
      return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, this.props));
    }
  }
  const mapStateToProps = state => {
    const isOpen = getOpenModal(state) === modalType;
    const props = isOpen ? getOpenModalMetadata(state) : {};
    return Object.assign({
      isOpen
    }, props);
  };
  const mapDispatchToProps = {
    onClose: closeModal
  };
  return connect(mapStateToProps, mapDispatchToProps)(HighOrderComponentWithModalProps);
}